import { observer } from "mobx-react-lite";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks";
import { useTran } from "@/hooks";
import { cn } from "@/lib/utils";

const ThemeSwitcher = observer(({ className }) => {
  const { t } = useTran();
  const theme = useTheme();

  return (
    <button
      onClick={() => theme.toggleTheme()}
      className={cn(
        "relative inline-flex h-8 w-8 items-center justify-center rounded-radius hover:bg-muted transition-colors",
        className,
      )}
      aria-label={t("Toggle theme")}
    >
      <Sun
        className={cn(
          "h-5 w-5 transition-all",
          theme.isDark ? "rotate-90 scale-0" : "rotate-0 scale-100",
        )}
      />
      <Moon
        className={cn(
          "absolute h-4 w-4 transition-all",
          theme.isLight ? "-rotate-90 scale-0" : "rotate-0 scale-100",
        )}
      />
      <span className="sr-only">{t("Toggle theme")}</span>
    </button>
  );
});

export default ThemeSwitcher;
